import { render, staticRenderFns } from "./Oelteltet.vue?vue&type=template&id=6185b8da&"
import script from "./Oelteltet.vue?vue&type=script&lang=js&"
export * from "./Oelteltet.vue?vue&type=script&lang=js&"
import style0 from "./Oelteltet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports